import { render, staticRenderFns } from "./MetaField.vue?vue&type=template&id=68420a18&scoped=true&"
import script from "./MetaField.vue?vue&type=script&lang=js&"
export * from "./MetaField.vue?vue&type=script&lang=js&"
import style0 from "./MetaField.vue?vue&type=style&index=0&id=68420a18&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68420a18",
  null
  
)

export default component.exports